import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as Utils from "../ts/rlAdmin.utils";

import * as _ from "lodash";
import * as angular from "angular";
import * as moment from "moment";

import { BaseEntityController } from "../controllers/baseEntityController";
import { FinancialService } from "../services/financial-service";
import { EntityService } from "../services/entity-service";
import { ListService } from "../services/list-service";
import { LocalCacheService } from "../services/local-cache-service";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { EntityConfigService } from "../services/entity-config-service";
import { SearchService } from "../services/search-service";
import { AclService } from "../services/acl-service";
import { ModalService } from "../services/modal-service";
import { AssetService } from "../services/asset-service";

export class FinancialDetailController extends BaseEntityController {
	static $inject = ["$scope", "$q", "$window", "$location", "$anchorScroll", "$sce",
		"financialService", "entityService", "listService", "localCacheService", "notifyService", "eventService",
		"entityConfigService", "searchService", "modalService", "assetService", "aclService"];

	entityID: string;
	entityRecord: Models.IEntity;
	entityCharDataCollection: Models.ICharDataCollection;
	editMode: boolean;
	visibility: number;
	isDeletable: boolean = false;
	amountTemplates: Models.ICharacteristicTemplate[];
	positiveAmountTemplates: Models.ICharacteristicTemplate[];
	negativeAmountTemplates: Models.ICharacteristicTemplate[];
	relatedAmountDocuments: Models.IEntitySearchDoc[];
	selectedAmounts: Models.IListTableRow[];
	positiveRelatedAmounts: Models.IEntitySearchDoc[];
	negativeRelatedAmounts: Models.IEntitySearchDoc[];
	relatedProperties: Models.IRecordRelationshipPairChild[];

	customColumns: Models.ICustomUserColumns;
	availableColumns: Models.IListTableColumn[];

	recordDocumentUrls: { [key: string]: string };
	documentModalTitle: string;
	documentModalOpen: boolean;
	documentViewSrc: string;
	locked: boolean;
	positiveTotal: number;
	negativeTotal: number;
	invoiceCurrencySym: string;
	invoiceCurrencyChar: Models.ICharDataValue;
	isValid: boolean;
	canEdit: boolean;
	canAdd: boolean;
	assetSearchModalOpen: boolean;
	selectedSearchAssets: { key: number, value: number }[];
	selectedSearchAssetIDs: number[];
	assetTemplates: Models.ICharacteristicTemplate[];
	parentEntity: Models.IEntityRelationship;
	parentEntityID: string;
	parentEntityCharTypeName: string;

	initialized: {
		details: boolean;
		properties: boolean;
		amounts: boolean;
		documents: boolean;
	};

	charDataIDsAndNames: Models.ICharacteristicType[];

	isOverdue: boolean;
	isOverDueDays: number;
	amountSortField: string;
	amountSortDir: number;
	lockedAmountRows: _.Dictionary<boolean>;
	allowedToDeleteRows: _.Dictionary<boolean>;

	amountPage: number;
	amountPageCount: number;
	amountNumFound: number;
	amountRowCount: number;

	catalogPage: number;
	catalogPageCount: number;
	catalogRowCount: number;
	catalogNumFound: number;
	catalogAssetChildCounts: { [key: number]: number };
	public catalogCharTypeId: number = Consts.CharTypeIDs.property;
	amountCatalogRels: { [key: number]: Models.IEntityRecIDTitle } = {};
	amountCatalogRelationships: { [entityID: string]: Models.IEntityRelationship[] } = {};
	forceRefresh: boolean = false;

	constructor(
		$scope: ng.IScope,
		$q: ng.IQService,
		private $window: ng.IWindowService,
		$location: ng.ILocationService,
		$anchorScroll: ng.IAnchorScrollService,
		private $sce: ng.ISCEService,
		private financialService: FinancialService,
		entityService: EntityService,
		private listService: ListService,
		localStorage: LocalCacheService,
		notifyService: NotifyService,
		private eventService: EventService,
		private entityConfigService: EntityConfigService,
		private searchService: SearchService,
		private modalService: ModalService,
		private assetService: AssetService,
		private aclService: AclService
	) {

		super($scope, $q, entityService, localStorage, notifyService, $location, $anchorScroll);

		this.entityID = "";
		this.entityRecord = null;
		this.entityCharDataCollection = null;
		this.editMode = false;
		this.visibility = 1;
		this.amountTemplates = [];
		this.positiveAmountTemplates = [];
		this.negativeAmountTemplates = [];
		this.relatedAmountDocuments = [];
		this.selectedAmounts = [];
		this.positiveRelatedAmounts = [];
		this.negativeRelatedAmounts = [];
		this.relatedProperties = [];
		this.initialized = {
			details: false,
			properties: false,
			amounts: false,
			documents: true
		};
		this.recordDocumentUrls = {};
		this.documentModalOpen = false;
		this.documentModalTitle = "";
		this.documentViewSrc = "";
		this.locked = false;
		this.positiveTotal = 0;
		this.negativeTotal = 0;
		this.invoiceCurrencySym = null;
		this.invoiceCurrencyChar = null;
		this.isValid = false;
		this.canEdit = false;
		this.canAdd = false;
		this.assetSearchModalOpen = false;
		this.selectedSearchAssets = [];
		this.selectedSearchAssetIDs = [];
		this.assetTemplates = [];
		this.parentEntity = null;
		this.parentEntityCharTypeName = "";
		this.isOverdue = false;
		this.lockedAmountRows = {};
		this.allowedToDeleteRows = {};

		this.amountRowCount = 10;
		this.amountPage = 1;

		this.catalogPage = 1;
		this.catalogRowCount = 10;
		this.catalogPageCount = 1;
		this.catalogNumFound = 0;


		$scope.$watch<boolean>(() => this.documentModalOpen,
			(newValue, oldValue) => {
				if (!newValue && oldValue) {
					this.documentModalTitle = "";
					this.documentViewSrc = "";
				}

			});


		$scope.$watch(() => this.amountTemplates,
			(newValue, oldValue) => {
				if (newValue != oldValue) {
					this.positiveAmountTemplates = _.filter(newValue, (template) => template.templateGroupID == 1);
					this.negativeAmountTemplates = _.filter(newValue, (template) => template.templateGroupID == 2);
				}
			}, true);
		$scope.$watch(() => this.catalogPage, (newValue, oldValue) => {
			if (newValue != oldValue) {
				this.RefreshProperties();
			}
		});

		$scope.$watch(() => this.catalogRowCount, (newValue, oldValue) => {
			if (newValue != oldValue) {
				this.RefreshProperties();
			}
		});
		$scope.$watch(() => this.relatedAmountDocuments,
			(newValue, oldValue) => {
				if (newValue != oldValue) {
					this.positiveRelatedAmounts = _.filter(newValue, (amount) => amount.templateGroupID == 1);
					this.negativeRelatedAmounts = _.filter(newValue, (amount) => amount.templateGroupID == 2);

					this.GetAmountTotal(this.positiveRelatedAmounts).then((total) => { this.positiveTotal = total; });
					this.GetAmountTotal(this.negativeRelatedAmounts).then((total) => { this.negativeTotal = total });
				}
			}, true);

		$scope.$watch(() => this.entityCharDataCollection != null ? this.entityCharDataCollection.charDatas : null,
			(newValue, oldValue) => {
				if (newValue != oldValue && newValue != null) {
					var currencyChar = Utils.CharUtil.GetCurrencyCharData(this.entityCharDataCollection);
					this.invoiceCurrencyChar = currencyChar;
					if (currencyChar != null) {
						this.invoiceCurrencySym = currencyChar.value;
					} else {

						_(this.entityCharDataCollection.templateMetaData.characteristicMetaDatas)
							.filter((cmd) => cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.money)
							.selectMany<Models.ICharacteristicMetaData, Models.ICharDataValue>((cmd) => this.entityCharDataCollection.charDatas[cmd.tagLabel])
							.forEach((cd) => {
								var moneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(cd.value, null);
								if (_.isObject(moneyValue)) {
									this.invoiceCurrencySym = moneyValue.locSym;
								}
							}).value();
					}
				}
			}, true);

		$scope.$watch(() => this.selectedSearchAssets, (newValue: { key: number, value: number }[]) => {
			this.selectedSearchAssetIDs = newValue.map(kvp => kvp.key);
		}, true);

		// clear selected assets whenever asset search modal is closed
		$scope.$watch(() => this.assetSearchModalOpen, (newValue: boolean, oldValue: boolean) => {
			// is closed & was opened
			if (!newValue && oldValue) {
				this.selectedSearchAssets = [];
			}
		}, true);

		$scope.$watch(() => {
			if (this.entityID == null) {
				return null;
			} else {
				return this.entityID;
			}
		},
			(newValue, oldValue) => {
				if (newValue != null) {
					this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
						return this.LoadEntity();
					});
				}
			});

		$scope.$watchCollection(() => [this.amountSortField, this.amountSortDir], (newValue) => {
			this.RefreshAmounts();
		});

		this.eventService.on(Consts.Events.RefreshTablesAndParents, () => {
			this.RefreshAll();
		});

		$scope.$watch(() => this.forceRefresh, (newValue, oldValue) => {
			if (newValue && !oldValue) {
				this.RefreshAmounts();
			}
		});
	}

	Init(entityID: string, canEdit: string, canAdd: string) {
		this.entityID = entityID;
		this.canEdit = canEdit == "True";
		this.canAdd = canAdd == "True";
		this.LoadCharDataIDsAndNames()
			.then(() => {
				this.getCharacteristicList(Consts.CharTypeIDs.amount);
				this.RefreshAll();
			});

	}


	private getCharacteristicList(charTypeID: number) {
		return this.entityConfigService.getCharacteristicList(charTypeID)
			.then((res) => {
				var columns = _.sortBy(res, (chr) => {
					return chr.label;
				}).map((chr): Models.IListTableColumn => {
					return {
						solrLabel: Utils.CharUtil.GetCharSolrLabel(chr.dataTypeID, chr.multipleIndicator, chr.tagLabel),
						label: chr.label,
						characteristicID: chr.characteristicID,
						formatter: Utils.CharUtil.GetFormatter(chr.dataTypeID),
						dataTypeID: chr.dataTypeID,
						systemIndicatorID: chr.systemIndicator
					}
				});

				this.availableColumns = columns;
			});
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	LoadEntity(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.entityService.getEntity(this.entityID)
			.then((result) => {
				this.entityRecord = result.record;
				this.entityCharDataCollection = result.charDataCollection;

				this.locked = result.charDataCollection.status.lockIndicator > 0;
				this.initialized.details = true;

				var promise1 = this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.invoice, this.entityRecord.templateID, Consts.CharTypeIDs.amount)
					.then((result) => {
						this.amountTemplates = result.filter(ct => Utils.AclUtil.hasCreateAccess(this.aclService.acls, ct.acl));
					});

				var promise2 = this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.invoice, this.entityRecord.templateID, Consts.CharTypeIDs.property)
					.then((result) => {
						this.assetTemplates = result.filter(ct => Utils.AclUtil.hasCreateAccess(this.aclService.acls, ct.acl));
					});

				var promise3 = this.entityService.getEntityParentRelationship(this.entityID)
					.then((results) => {
						if (results != null && results.length > 0) {
							var parent = _.first(results.filter(r => Utils.CharUtil.IsModuleLevelCharType(r.parentCharTypeID)));

							this.parentEntity = parent;
							this.parentEntityID = Utils.IdBuilder.buildEntityID(parent.divisionID, parent.parentCharTypeID, parent.parentRecID);
							this.parentEntityCharTypeName = _.find(this.charDataIDsAndNames, c => c.charTypeID == parent.parentCharTypeID).charTypeName;
						}
					});

				return this.$q.all([promise1, promise2, promise3]);
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	SaveEntity() {
		this.notifyService.startProgress();
		return this.entityService.saveCharData(this.entityID, this.entityCharDataCollection.charDatas)
			.then(() => {
				this.notifyService.notifySuccess("Successfully Saved");
			}, this.notifyService.errorResponseHandler)
			.then(() => {
				this.RefreshValidation();
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Edit() {
		this.editMode = true;
	}

	Cancel() {
		this.notifyService.startProgress();
		this.LoadEntity()
			.then(() => {
				this.editMode = false;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Save(isValid: boolean) {
		if (!isValid) {
			this.notifyService.notifyError("Correct Errors");
		} else {
			return this.SaveEntity()
				.then(() => {
					this.editMode = false;
					this.RefreshValidation();
					this.RefreshAmounts();
					this.IsInvoiceOverdue();
				});
		}
	}

	RefreshAll(): ng.IPromise<any> {
		var promises = [
			this.LoadEntity(),
			this.RefreshAmounts(),
			this.RefreshProperties()
		];

		return this.$q.all(promises)
			.then(() => {
				return this.RefreshValidation()
					.then(() => {
						this.initialized.documents = false;
						this.IsInvoiceOverdue();
					});
			});
	}

	RefreshAmounts(): ng.IPromise<any> {
		this.notifyService.startProgress();
		this.relatedAmountDocuments = [];
		return this.searchService.advancedSearch({
			charTypeID: Consts.CharTypeIDs.amount,
			relatedEntityID: this.entityID,
			searchGroups: [],
			keywords: undefined,
			rowCount: this.amountRowCount,
			page: this.amountPage,
			sortDir: this.amountSortDir,
			sortField: this.amountSortField
		})
			.then((res) => {
				this.lockedAmountRows = {};
				this.allowedToDeleteRows = {};
				var promises = [];

				if (_.any(res.documents)) {
					var recordIDs = res.documents.map(doc => doc.recordID);
					var promise = this.entityService.getEntityStatuses(Consts.CharTypeIDs.amount, recordIDs)
						.then(result => {
							this.lockedAmountRows = _.transform<Models.IEntityStatus, boolean>(result, function (acc, value, key) { (acc[key] = value.lockIndicator > 0) }, {});
							this.allowedToDeleteRows = _.transform<Models.IEntityStatus, boolean>(result, function (acc, value, key) { (acc[key] = value.deleteIndicator > 0) }, {});
						});
					promises.push(promise);
				}
				return this.$q.all(promises)
					.then(() => {
						this.initialized.amounts = true;
						this.relatedAmountDocuments = res.documents;

						this.amountNumFound = res.numFound;
						this.amountPageCount = Math.ceil(res.numFound / this.amountRowCount);

					});
			})
			.finally(() => {
				this.forceRefresh = false;
				this.notifyService.endProgress();
			});
	}

	AmountPageSizeChanged(pageSize: number) {
		this.amountRowCount = pageSize;
		this.amountPage = 1;
		this.RefreshAmounts();
	}

	AmountPageChanged(page: number) {
		this.amountPage = page;
		this.RefreshAmounts();
	}

	RefreshProperties(): ng.IPromise<any> {
		this.notifyService.startProgress();

		var promise1 = this.assetService.searchEntityAssets(this.entityID, null, this.catalogPage, this.catalogRowCount)
			.then((result) => {
				this.relatedProperties = [];
				this.relatedProperties = result.assets;
				this.catalogAssetChildCounts = result.assetChildCounts;
				this.catalogNumFound = result.numFound;
				this.catalogPageCount = Math.ceil(this.catalogNumFound / this.catalogRowCount) || 1;
				this.initialized.properties = true;
			});
		return this.$q.all([promise1])
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	NewAmount(template: Models.ICharacteristicTemplate, $event: ng.IAngularEvent) {
		$event.preventDefault();
		var templateID = Utils.IdBuilder.buildTemplateID(this.entityRecord.divisionID, Consts.CharTypeIDs.amount, template.templateID);
		this.entityConfigService.getRelatedConfigurationCharacteristicTypes(Consts.CharTypeIDs.amount).then((ctResult) => {
			this.modalService.createEntityByTemplate(templateID, this.entityID, undefined, ctResult.map(i => i.charTypeID), false, null, true)
				.then((res) => {
					this.notifyService.notifySuccess("Amount Created");
					this.RefreshAmounts();
					this.LoadEntity();
				})
				.then(() => {
					this.RefreshValidation();
				});
		});
	}

	RemoveAsset(asset: Models.IEntityRelationshipPair) {
		if (this.$window.confirm("Are you sure you want to delete this Catalog Item?")) {
			this.notifyService.startProgress();

			var relID = Utils.IdBuilder.buildEntityID(asset.record.divisionID, Consts.CharTypeIDs.relationship, asset.relationship.relRecID);
			this.financialService.removeAsset(relID)
				.then(
					() => {
						this.notifyService.notifySuccess("Catalog Item removed");
						return this.RefreshProperties();
					},
					() => {
						this.notifyService.notifyError("Error removing Catalog Item");
					})
				.then(() => {
					this.RefreshValidation();
				})
				.finally(() => {
					this.notifyService.endProgress();
				});

		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	private ParseFloat(val: string): number {
		return parseFloat(val.replace(/[^0-9\.\\-]/g, "")) || 0;
	}

	GetAmountTotal(amounts: Models.IEntitySearchDoc[]) {
		let deferred = this.$q.defer<number>();

		let promiseCompletion = 0;
		let total = 0;
		let amountGroups = _.groupBy(amounts, (amt) => {
			return amt.templateID;
		});

		let promises: ng.IPromise<any>[] = [];
		_.forOwn(amountGroups, (amounts, templateID) => {
			promises.push(this.entityService.getEmptyEntityCharData(Utils.IdBuilder.buildTemplateID(0, Consts.CharTypeIDs.amount, amounts[0].templateID))
				.then((metaData) => {
					_.forEach(amounts, (amt) => {
						let amountCmd = _.find(metaData.templateMetaData.characteristicMetaDatas, cmd => cmd.tagLabel == "amount");
						if (!_.isUndefined(amountCmd)) {
							let solrLabel = Utils.CharUtil.GetCharSolrLabelByCmd(amountCmd);
							var amountValue = amt.characteristics[solrLabel];
							if (amountValue != null) {
								if (amountCmd != null && amountCmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.money) {
									//var moneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(amountValue, null);
									var moneyValue = amountValue.split(' ')[1];
									if (!_.isEmpty(moneyValue)) {
										total += this.ParseFloat(moneyValue);
									}
								} else {
									total += this.ParseFloat(amountValue.toString());
								}
							}
						}
					});
				}));

			this.$q.all(promises)
				.then(() => {
					promiseCompletion++;

					if (promiseCompletion == promises.length) {
						deferred.resolve(total);
					}
				});
		});

		return deferred.promise;
	}

	Delete() {
		if (this.$window.confirm("Are you sure you want to delete this Accounting Document?") && this.$window.confirm("Are you REALLY SURE you want to delete this Accounting Document?")) {
			this.notifyService.startProgress();
			this.financialService.deleteInvoice(this.entityID)
				.then(() => {
					this.$window.location.assign(Consts.Urls.FinancialListPage);
				},
					() => {
						this.notifyService.notifyError("Error Deleting Accounting Document");
					})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	AddAsset() {
		this.assetSearchModalOpen = true;
	}

	AssociateAssets() {
		this.notifyService.startProgress();
		var invoiceRecID = Utils.IdBuilder.splitEntityID(this.entityID).recID;

		this.financialService.associateAssets(invoiceRecID, this.selectedSearchAssetIDs)
			.then(() => {
				this.notifyService.notifySuccess("Assets Associated");
				return this.RefreshProperties();
			}, () => {
				this.notifyService.notifyError("Error Associating Assets");
			})
			.then(() => {
				this.RefreshValidation();
				this.assetSearchModalOpen = false;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});

	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}

	LoadCharDataIDsAndNames() {
		this.charDataIDsAndNames = [];

		return this.entityConfigService.getCharacteristicTypes()
			.then((results) => {
				this.charDataIDsAndNames = results;

				//We need to make sure this says Accounting and not Invoice
				var invoiceCharType = _.find(this.charDataIDsAndNames, c => c.charTypeID == 7);
				invoiceCharType.charTypeName = "Accounting";
			})
	}

	GetCharDataName(charTypeID: number): string {
		return _.find(this.charDataIDsAndNames, c => c.charTypeID == charTypeID).charTypeName;
	}

	IsInvoiceOverdue() {
		this.isOverdue = false;
		this.isOverDueDays = 0;

		//Is there a positive balance?
		if (this.positiveTotal - this.negativeTotal > 0) {
			//Check to see if today is past the due date, if so, the invoice is overdue
			if (!_.isUndefined(this.entityCharDataCollection.charDatas["due_date"]) && this.entityCharDataCollection.charDatas["due_date"].length > 0) {
				var dueDateValue = this.entityCharDataCollection.charDatas["due_date"][0].value;

				if (dueDateValue != null) {
					var dueDate = moment(dueDateValue, "MM/DD/YYYY");
					var today = moment();

					if (dueDate.format("MM/DD/YYYY") != Consts.DateMath.BlankDateValue && today > dueDate) {
						this.isOverdue = true;
						this.isOverDueDays = Math.floor(moment.duration(today.diff(dueDate)).asHours() / 24);
					}
				}
			}
		}
	}
}
